import "./../../bindings/bao-toolbar2";
import "./../../bindings/bao-upload";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
import TabPage from "./../../factories/tab-page";
import Bao from "./../../services/bao-service";
import WorkItemType from "../work-item-type";

/**
 * ViewModel for WorkItemCollectionWorkItemTypeTab
 */
class WorkItemCollectionWorkItemTypeTab extends GenericListSearchTab {

    // #region Constructor

    /** 
     *Constructor
     */
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.Parent = parent;

        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }

    // #endregion Constructor

    // #region Properties

    /**
     *  Bao object to access session objects
     */
    Bao = Bao;

    /**
     * Controller Url 
     */
    ControllerUrl = "WorkItemCollectionWorkItemTypeTab";

    /**
     * Parent of Tab
     */
    Parent: WorkItemType;

    // #endregion Properties

    // #region Public Methods

    /**
     * Returns custom filters
     * @returns Custom filters
     */
    CustomFilter = (): Models.HashObject[] => {
        let customFilterHashObject: Models.HashObject[] = [];
        return customFilterHashObject;
    }

    /**
     * Checks if the view model has been set correctly
     * @returns JqueryPromise<boolean>
     */
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        let def = $.Deferred<boolean>();
        return def.promise();
    }

    /**
     * Returns name of search type
     * @returns Name of search type
     */
    SearchType() {
        return "WorkManagmentWorkItemCollection";
    }

    /**
    * Override init method to not override title set by parent Module
    * @returns JQuery Promise
    */
    init(): JQueryPromise<void> {
        this.TabPage.IsLoading(true);

        return Bao.post(this.UrlInit(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: this.GetParentId(),
            customFilter: this.CustomFilter(),
            sorting: this.Sorting(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result: Factories.GenericListResponse.InitResponse) => {
            this.Models(result.Models);
            this.TotalRows(result.TotalRows);
            this.PermissionAdd = result.Definition.PermissionAdd;
            this.PermissionEdit = result.Definition.PermissionEdit;
            this.PermissionRemove = result.Definition.PermissionRemove;
            this.BindingToolbar.formName = result.Definition.FormName;
            this.BindingToolbar.applicationId = result.Definition.ApplicationId;
            this.TabPage.DirtyFlag.reset();
        }).always(() => {
            this.TabPage.IsLoading(false);
        });
    }

    /**
    * Check for empty/null value
    * @returns boolean result
    */
    IsShiftBookIdEmpty = (shiftbookId : string) => {
        return Bao.Utils.String.IsNullOrEmpty(shiftbookId);
    }

    // #endregion Public Methods
}
export default WorkItemCollectionWorkItemTypeTab;